module.exports = __webpack_public_path__ + "img/12.b707e2d8.gif";